import { Component } from 'react';
import {connect} from 'react-redux';
import {Container} from 'react-bootstrap';
import PageTitle from '../../../common/page-title';
import UsersList from './users-list';
import {getUsers} from '../../../../actions/users';

import './styles.css';
import UsersSearch from './users-search';
import LinkButton from '../../../common/link-button';

class Users extends Component {
  state = {
    query: '',
    status: '',
    userGroup: '',
    pageNumber: 1
  };

  handleInputChange = (e) => {
    this.setState({query: e.target.value});
  };

  handleStatusFilterChange = (e) => {
    this.setState({status: e.target.value});
  };

  handleGroupFilterChange = (e) => {
    this.setState({userGroup: e.target.value});
  };

  handleSearch = () => {
    const {
      query, userGroup, status, pageNumber
    } = this.state;
    this.props.dispatch(getUsers(query, userGroup, status, pageNumber));
  };

  handleClear = () => {
    this.setState({
      query: '',
      userGroup: '',
      status: '',
      pageNumber: 1
    }, this.handleSearch);
  };

  handlePageChange = (page) => {
    this.setState({pageNumber: page}, this.handleSearch);
  };

  UNSAFE_componentWillMount() {
    this.handleSearch();
  }

  render() {
    return (
      <Container fluid className="users">
        <PageTitle>
          Users
        </PageTitle>
        <LinkButton
          to="/admin/users/new"
          arrow={false}
          className="add-user"
          permissions={{
            action: 'create',
            subjectClass: 'User'
          }}
          submit={false}
        >
          Add user
        </LinkButton>

        <UsersSearch
          onClear={this.handleClear}
          onInputChange={this.handleInputChange}
          onSearch={this.handleSearch}
          onStatusFilterChange={this.handleStatusFilterChange}
          onUserGroupFilterChange={this.handleGroupFilterChange}
          searchValue={this.state.query}
          statuses={this.props.statuses}
          statusFilterValue={this.state.status}
          userGroupFilterValue={this.state.userGroup}
          userGroups={this.props.userGroups}
        />
        <UsersList
          fetched={this.props.fetched}
          fetching={this.props.fetching}
          users={this.props.users}
          currentPage={this.state.pageNumber}
          onPageChange={this.handlePageChange}
          paging={this.props.paging}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users.users,
  fetched: state.users.fetched,
  fetching: state.users.fetching,
  userGroups: state.users.listInput.userGroups,
  statuses: state.users.listInput.statuses,
  paging: state.users.paging
});

export default connect(mapStateToProps)(Users);
